import { useAuthContext } from '@aibees/shared/auth';
import { MemberStatus, UserRelation } from '@aibees/shared/definition';
import { useWorkspace } from '../context';

export function useWorkspaceUsers(active?: boolean): UserRelation[] {
  const workspace = useWorkspace();
  const { user } = useAuthContext();

  const allMembers = workspace
    ? [
        ...[workspace.user],
        ...workspace.members
          .filter((i) => (!active ? true : i.status === MemberStatus.Active))
          .map((i) => i.user),
      ]
    : [];

  return allMembers
    .filter(
      (row, index, self) => index === self.findIndex((r) => r?.id === row?.id)
    )
    .filter((x) => !!x)
    .map((member) =>
      member.id === user?.id ? { ...member, ...{ current: true } } : member
    );
}
